import { Form, FormItemProps, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';

export const generateName = (rootName, name) => {
  if (rootName && !name) return [rootName];

  if (rootName)
    return Array.isArray(name) ? [rootName, ...name] : [rootName, name];

  return name;
};

export default function FormItem({
  children,
  name,
  label,
  rootName,
  ...props
}: FormItemProps & {
  rootName?: string;
  placeholder?: string;
  prefix?: React.ReactNode;
  maxLength?: number;
  showCount?: boolean;
  disbaled?: boolean;
  formOptions?: DynamicObjectType;
  ruleType?: string;
}) {
  const { t } = useTranslation();
  const {
    placeholder,
    prefix,
    maxLength,
    required,
    rules,
    showCount,
    disbaled,
    formOptions,
    ruleType,
    initialValue,
  } = props;
  return (
    <Form.Item
      {...props}
      name={generateName(rootName, name)}
      label={typeof label === 'string' ? t(label) : label}
      rules={required ? [{ required: true }] : rules}
      initialValue={
        (initialValue && initialValue !== 'undefined') ||
        typeof initialValue === 'number'
          ? normalize(ruleType, initialValue, null)
          : undefined
      }
      {...formOptions}
    >
      {children || (
        <Input
          placeholder={placeholder}
          prefix={prefix}
          maxLength={maxLength}
          showCount={showCount}
          disabled={disbaled}
        />
      )}
    </Form.Item>
  );
}

const normalize = (ruleType, value, allowNull) => {
  switch (ruleType) {
    case 'number':
      return value === null ? (allowNull ? null : 0) : Number(value);
    case 'array':
      return Array.isArray(value)
        ? value
        : value?.split(',')?.filter((e) => e) || [];
    default:
      return value;
  }
};
